// Los pagos registrados desde un traslado (lote) se graban como "Aprobado" para
// descontar la cuenta corriente, pero el cliente debe ver el estado del lote.
export const ESTADO_PAGO_PENDIENTE_COBRO = "Pendiente de cobro";
export const ESTADO_PAGO_PAGADO = "Pagado";

const ESTADO_LOTE_VISIBLE = {
	PENDIENTE: ESTADO_PAGO_PENDIENTE_COBRO,
	PAGADO: ESTADO_PAGO_PAGADO,
};

export const getPagoEstadoVisible = (pago) => {
	const estado = pago?.estado || null;
	if (!pago?.estadoLote || String(estado || "").toUpperCase() !== "APROBADO") return estado;
	return ESTADO_LOTE_VISIBLE[String(pago.estadoLote).trim().toUpperCase()] || estado;
};

export const TITULO_PAGO_LOTE_DEFAULT = "Transferencia de deuda a UPrO";

export const getPagoTitulo = (pago, fallback = "Pago") => {
	const leyenda = String(pago?.leyenda || "").trim();
	if (leyenda) return leyenda;
	return pago?.idLote || pago?.estadoLote ? TITULO_PAGO_LOTE_DEFAULT : fallback;
};
